<template>
  <v-app-bar max-height="70px" color="#d72626" dark>
    <v-icon x-large class="pa-2">mdi-folder-arrow-up-outline</v-icon>
    <v-toolbar-title>HONDA PPS</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-0" icon v-bind="attrs" v-on="on">
          <v-icon style="font-size: 28px" color="white"
            >mdi-account-outline</v-icon
          >
        </v-btn>
      </template>
      <v-list>
        <div class="text-h5 grey--text text--darken-3 px-4 pt-4">
          {{ $keycloak.idTokenParsed.name }}
        </div>
        <div class="subtitle-2 primary--text font-weight-regular px-4">
          {{ $keycloak.idTokenParsed.email }}
        </div>
        <div class="d-flex justify-center my-3">
          <v-btn
            width="80%"
            large
            outlined
            color="primary"
            class="text-capitalize"
            @click="$keycloak.logout({ redirectUri: logoutUri })"
            >Sair
          </v-btn>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
export default {
  name: "App-bar",

  components: {},
  data() {
    return {
      logoutUri: process.env.BASE_URL,
    };
  },
  methods: {},
};
</script>
<style scoped>
.f-row {
  background: red;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
